import axios from "axios";
import { env } from "../utils/utils";
import { AppState } from "./rootReducer";
import { Dispatch } from "redux";

export const Actions = {
  UPDATE_DATA: "UPDATE_DATA",
  RESET_SCREENS: "RESET_SCREENS",
};

/**
 * fetch all data from backend and update state
 */
export const updateData = () => {
  return (dispatch: Dispatch) => {
    console.log("fetching data");
    axios
      .get<AppState>(env("SERVER_URL") + "/all")
      .then((response) => {
        dispatch({ type: Actions.UPDATE_DATA, payload: response.data });
        console.log("data fetched", response.data, "bingus");
      })
      .catch((error) => {
        console.error("updateData error", error.message);
      });
  };
};

export const resetScreens = () => {
  return (dispatch: Dispatch) => {
    dispatch({ type: Actions.RESET_SCREENS, payload: null });
  };
};
